import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../../services/Api'

const anexosRepository = createRepository({
  parentPath: 'tarefas',
  path: 'anexos',
  relationType: 'path',
  restApi
})

anexosRepository.uploadAnexos = (tarefaId, data, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify(data))
  return restApi.post(`tarefas/${tarefaId}/anexos`, formData, {
    header: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

export default anexosRepository
